
import { Link } from "react-router-dom";

import {
  Container,
  Header,
  Segment,
} from 'semantic-ui-react'

import { gql, useQuery } from '@apollo/client';

import { InterimStates } from "../InterimStates";

import { PATHS } from "../../paths";

const GET_SUPPORTIES = gql`
query Supporties {
  supporties {
    id
    name
  }
}
`;

const Supporties = () => {
    const { loading, error, data } = useQuery(GET_SUPPORTIES);

    if (loading || error) {
        return <InterimStates loading={loading} error={error} label='overview' />
    }
    return (
        <>
            {data.supporties.map((s: any) => (
              <Segment key={s.id}>
                <Header as='h2'>{s.name}</Header>
                <Link to={`${PATHS.PEOPLE}/${s.id}`}>
                {s.name}
                </Link>
              </Segment>
            ))}
        </>
    )
}

const GET_OVERVIEW = gql`
query Overview {
  overviews {
    classCount
    personCount
    title
  }
}`;

const Overview = () => {
    const { loading, error, data } = useQuery(GET_OVERVIEW);

    if (loading || error) {
        return <InterimStates loading={loading} error={error} label='overview' />
    }

    return (
      <Segment style={{ padding: '2em 0em' }} vertical>
        <Container>
            <Header as='h1'>Your buddies</Header>
            <Supporties />

            <Header as='h1'>Communities</Header>
            {data.overviews.map((overview: any) => (
              <Segment key={overview.title}>
                <Header as='h2'>{overview.title}</Header>
                <p>Classes: {overview.classCount}</p>
                <p>People: {overview.personCount}</p>
                </Segment>
            ))}
        </Container>
      </Segment>
  )
}

export { Overview }
